import { render } from "./AmazonIcon.vue?vue&type=template&id=6b705804"
import script from "./AmazonIcon.vue?vue&type=script&lang=js"
export * from "./AmazonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__